export const LOCAL_GEOJSON = {
  name: "GeoJson",
  basePath: "static/data"
};

export const EMODNET_WMS_HUMAN_ACTIVITIES = {
  name: "Emodnet",
  url: "https://ows.emodnet-humanactivities.eu/wms"
};

export const EMODNET_WMS_BATHYMETRY = {
  name: "Emodnet-Bathymetry",
  url: "https://ows.emodnet-bathymetry.eu/wms",
  identifyUrl: "https://rest.emodnet-bathymetry.eu/depth_sample"
};

export const EMODNET_WMS_GEOLOGY_SUBSTRATE = {
  name: "Emodnet-Geology",
  url: "http://drive.emodnet-geology.eu/geoserver/gtk/wms"
};

export const EMODNET_WMS_GEOLOGY_BEDROCK = {
  name: "Emodnet-Geology-Bedrock",
  url: "http://drive.emodnet-geology.eu/geoserver/bgr/wms"
};

export const EMODNET_WMS_SEABED_HABITATS = {
  name: "Emodnet-Habitats",
  url: "https://ows.emodnet-seabedhabitats.eu/emodnet_view/wms"
};

export const THREDDS = {
  name: "Thredds",
  baseUrl: process.env.VUE_APP_THREDDS_BASE_URL,
  ncssUrl: `${process.env.VUE_APP_THREDDS_BASE_URL}/ncss/grid`,
  wmsUrl: `${process.env.VUE_APP_THREDDS_BASE_URL}/wms`
};

export const THREDDS_MSP = {
  name: "Thredds_MSP",
  wmsUrl: `${THREDDS.wmsUrl}/msp`,
  ncssUrl: `${THREDDS.ncssUrl}/msp`
  /*
         Sample of standard options
           layers: '',
           styles: '',
           format: 'image/png',
           transparent: true,
           version: '1.1.1',
           crs: 'EPSG:4326'
         Sample of Thredds options:
           bbox: '-19,26,5,56',
           width: 256,
           height: 256,
           colorscalerange: '0, 8',
           numcolorbands:20,
           styles: 'boxfill/redblue'
           time: 2018-08-31T05:00:00.000Z
         */
};
